import { matchPath } from 'react-router-dom'
import { ROUTES } from 'Utils/constants'

export const getCustomerDisplayQuoteState = (
  pathname,
  quote,
  loadState,
  discountState
) => {
  const match = matchPath(pathname, {
    path: `${ROUTES.editQuoteHeaderId}:header/:id`,
    exact: true,
  })
  if (!match) return null

  const { header, id } = match.params
  const sameId = value =>
    String(value || '').toLowerCase() === header.toLowerCase()
  const sameNumber = value => String(value || '') === id
  const isCurrentLoad =
    sameId(loadState?.headerId) && sameNumber(loadState?.documentNumber)
  const hasError = isCurrentLoad && loadState.hasError === true
  const hasCurrentQuote =
    sameId(quote?.QuoteHeaderId || quote?.DocHeaderId) &&
    sameNumber(quote?.DocumentNumber)
  const isLoading =
    !hasError &&
    (!isCurrentLoad || loadState.isLoading !== false || !hasCurrentQuote)

  const isLoaded = !isLoading && !hasError
  // Prefer the Descuento column the seller sees; until the quote table reports
  // it, fall back to the stored option instead of keeping another quote's value.
  const showDiscount = sameId(discountState?.headerId)
    ? discountState.showDiscount
    : quote?.ShowDiscountOption

  return {
    isDetailQuote: true,
    isLoadingDetailQuote: isLoading,
    quoteLoadFailed: hasError,
    quoteData: isLoaded ? quote : {},
    ...(isLoaded && typeof showDiscount === 'boolean' ? { showDiscount } : {}),
  }
}
